import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import {formatDate} from "@ui-seeker/utils";
import { dsColorNew } from "@palette"

export default function datesHeader(header, subHeaders) {

    return {
        setHeaderCellProps: () => ({ sx:{ p: 0, borderBottom: 0, minWidth: 270, backgroundColor: dsColorNew.tableHead } }),
        render: () => <Box key={`${header}-${subHeaders.join("-")}`}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: 1,
                backgroundColor: dsColorNew.tableHead,
                pt: 1,
            }}>
                <Typography sx={{ fontWeight: 'bold' }} >{formatDate(header, {isString: true, format: 'dd/MM'})}</Typography>
                    <Box sx={{ backgroundColor: dsColorNew.navy, color: dsColorNew.white, px: 2, width: '100%' }}>
                        <Grid container spacing={1}>
                            {subHeaders.map((subHeader, idx) =><Grid key={`${header}-${subHeader}-${idx}`} item xs={12 / subHeaders.length}>
                                <Typography sx={{ fontWeight: 'bold' }} >{subHeader}</Typography>
                            </Grid>)}
                        </Grid>
                    </Box>
            </Box>
        </Box>
    }
}